import React, { Fragment } from "react";
import "./style.css";
import { useNavigate, useLocation, NavLink, useParams } from "react-router-dom";
import logoSymbol from "../../assets/images/logoSymbol.png";
import { Typography } from "@mui/material";
import { navMenuItems, pageConstant } from "../../config/pageConstant";
import { hasAccess } from "../../common/commonFunctions";
import ClientAccountSelector from "./clientAccountSelector";
import { Icon } from "@iconify/react";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import _ from "lodash";

const VerticalNav = ({ closeVerticalNav }: any) => {
  const navigate = useNavigate();
  const location = useLocation();

  const { ticker_in } = useParams();

  const onNavigate = (page: string, param: string) => {
    if (page === "/sl-quote") {
      navigate(`${page}${param}`);
    }

    closeVerticalNav();
  };

  const handleClickNewTab = (url: string) => {
    const path = window.location.href;
    const myArray = path.split("#");
    const openWindow = myArray[0] + "#" + url;
    window.open(openWindow, "", "fullscreen=yes,location=0");
  };

  const isParentActive = (parentPath: any) => {
    return (
      location.pathname === parentPath ||
      location.pathname.startsWith(parentPath + "/")
    );
  };

  return (
    <>
      <div>
        <div
          className="navbar-brand d-flex flex-row justify-content-between"
          style={{ backgroundColor: "#6a7587" }}
        >
          <div className="d-flex flex-row justify-content-start">
            <img
              src={logoSymbol}
              onClick={() => onNavigate("/dashboards/sl-quote/MSFT", "")}
              className="headerSymbol mt-1 d-flex align-items-center ms-1"
              alt="Logo"
            />
            <Typography className="ms-1" color={"#ffff"} fontSize={"1.5rem"}>
              SL Trader
            </Typography>
          </div>
          <div className="d-flex flex-row justify-content-end align-items-center pe-1">
            <Icon
              icon={"si:close-line"}
              fontSize={28}
              color={"#ffff"}
              onClick={closeVerticalNav}
            ></Icon>
          </div>
        </div>
      </div>
      <div className="sidebar">
        <div className="menu-vertical">
          <header className="nav-header">
            <nav className="navbar ">
              <ul className="menu-vertical d-flex flex-column justify-content-between">
                {navMenuItems?.map((menu: any) => {
                  return (
                    <>
                      {hasAccess(menu?.permissions) && (
                        <>
                          <li className="dropdown-item">
                            <NavLink
                              onClick={(e) => e.preventDefault()}
                              to={``}
                              className={({ isActive }) =>
                                isParentActive(menu?.link)
                                  ? "active-link-vertical"
                                  : ""
                              }
                            >
                              <span className="d-flex flex-row align-items-center">
                                <Icon
                                  className="me-1 align-items-center"
                                  icon={menu?.icon}
                                  fontSize={"1.2rem"}
                                ></Icon>
                                {menu?.label}
                              </span>
                            </NavLink>

                            <ul className="submenu-vertical">
                              {menu?.submenu?.map((subMenu: any) => {
                                return (
                                  <>
                                    {(subMenu.link ==='/locates-client' ?!hasAccess([`${pageConstant.LOCATE_DASHBOARD}_ADMIN`,`${pageConstant.LOCATE_DASHBOARD}_RW`, `${pageConstant.LOCATE_DASHBOARD}_RO`]) && hasAccess(subMenu?.permissions):(hasAccess(subMenu?.permissions))) && (
                                      <>
                                        <li>
                                          <NavLink
                                            onClick={() => {
                                              closeVerticalNav?.();
                                            }}
                                            to={`${
                                              subMenu.link === "/sl-quote"
                                                ? `/dashboards/sl-quote/${
                                                    ticker_in &&
                                                    !_.isEmpty(ticker_in) &&
                                                    ticker_in?.length > 0
                                                      ? ticker_in
                                                      : "MSFT"
                                                  }`
                                                : `${menu.link}${subMenu.link}`
                                            }`}
                                            className={({ isActive }) =>
                                              isActive ? "active-link" : ""
                                            }
                                          >
                                            {subMenu?.label}
                                            <OpenInNewIcon
                                              className="ms-1"
                                              onClick={(e: any) => {
                                                e?.preventDefault();
                                                handleClickNewTab(
                                                  `${
                                                    subMenu.link === "/sl-quote"
                                                      ? `/dashboards/sl-quote/${
                                                          ticker_in &&
                                                          !_.isEmpty(
                                                            ticker_in
                                                          ) &&
                                                          ticker_in?.length > 0
                                                            ? ticker_in
                                                            : "MSFT"
                                                        }`
                                                      : `${menu.link}${subMenu.link}`
                                                  }`
                                                );
                                                closeVerticalNav?.();
                                              }}
                                              style={{ fontSize: "0.8rem" }}
                                            />
                                          </NavLink>
                                        </li>
                                      </>
                                    )}
                                  </>
                                );
                              })}
                            </ul>
                          </li>
                        </>
                      )}
                    </>
                  );
                })}
              </ul>
            </nav>
          </header>
        </div>

        <div className="bottom-div">
          <ClientAccountSelector isHorizontalNav={false} />
        </div>
      </div>
    </>
  );
};

export default VerticalNav;
